#import "./plannedBreakInfo.gql"

mutation CreatePlannedBreak(
  $id: ID!
  $name: String
  $startTime: String
  $endTime: String
  $monday: Boolean!
  $tuesday: Boolean!
  $wednesday: Boolean!
  $thursday: Boolean!
  $friday: Boolean!
  $saturday: Boolean!
  $sunday: Boolean!
  $lineIds: [ID!]!
) {
  createPlannedBreak(
    id: $id
    name: $name
    startTime: $startTime
    endTime: $endTime
    monday: $monday
    tuesday: $tuesday
    wednesday: $wednesday
    thursday: $thursday
    friday: $friday
    saturday: $saturday
    sunday: $sunday
    lineIds: $lineIds
  ) {
    plannedBreak {
      ...plannedBreakInfo
    }
  }
}

mutation UpdatePlannedBreak(
  $id: ID!
  $name: String!
  $startTime: String
  $endTime: String
  $monday: Boolean!
  $tuesday: Boolean!
  $wednesday: Boolean!
  $thursday: Boolean!
  $friday: Boolean!
  $saturday: Boolean!
  $sunday: Boolean!
  $lineIds: [ID!]!
) {
  updatePlannedBreak(
    id: $id
    name: $name
    startTime: $startTime
    endTime: $endTime
    monday: $monday
    tuesday: $tuesday
    wednesday: $wednesday
    thursday: $thursday
    friday: $friday
    saturday: $saturday
    sunday: $sunday
    lineIds: $lineIds
  ) {
    plannedBreak {
      ...plannedBreakInfo
    }
  }
}

query GetAllPlannedBreaks {
  plannedBreaks {
    ...plannedBreakInfo
  }
}

query GetPlannedBreak($id: ID!) {
  plannedBreak(id: $id) {
    ...plannedBreakInfo
  }
}

mutation DeletePlannedBreak($id: ID!) {
  deletePlannedBreak(id: $id) {
    name
  }
}

subscription OnPlannedBreakCreated {
  plannedBreakCreated {
    plannedBreak {
      id
    }
  }
}

subscription OnPlannedBreakDeleted {
  plannedBreakDeleted {
    plannedBreak {
      id
    }
  }
}

subscription OnPlannedBreakUpdated {
  plannedBreakUpdated {
    plannedBreak {
      id
    }
  }
}
